import React, { useState, useEffect } from 'react';
import { collection, query, where, onSnapshot, limit } from 'firebase/firestore';
import { db } from '../../firebase/config'; // Adjust path if needed

export default function VendorAutocomplete({ appId, onVendorSelect, initialValue }) {
    const [searchTerm, setSearchTerm] = useState(initialValue || '');
    const [results, setResults] = useState([]);
    const [showResults, setShowResults] = useState(false);

    useEffect(() => {
        if (searchTerm.length < 2) {
            setResults([]);
            return;
        }

        // --- UPDATED: Convert search term to lowercase ---
        const lowercasedSearchTerm = searchTerm.toLowerCase();

        // --- UPDATED: Query the new 'searchableName' field ---
        const q = query(
            collection(db, `/artifacts/${appId}/public/data/vendors`),
            where("status", "==", "Active"),
            where("basicInfo.searchableName", ">=", lowercasedSearchTerm),
            where("basicInfo.searchableName", "<=", lowercasedSearchTerm + '\uf8ff'),
            limit(10)
        );

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const vendorsData = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
            setResults(vendorsData);
            setShowResults(true);
        });

        return () => unsubscribe();
    }, [searchTerm, appId]);

    const handleSelect = (vendor) => {
        setSearchTerm(vendor.basicInfo.legalName);
        onVendorSelect(vendor.basicInfo.legalName);
        setShowResults(false);
    };

    return (
        <div className="relative">
            <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onFocus={() => setShowResults(true)}
                onBlur={() => setTimeout(() => setShowResults(false), 200)}
                placeholder="Type to search for a vendor..."
                className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-[#20BEC6] focus:border-[#20BEC6] disabled:bg-gray-100"
            />
            {showResults && results.length > 0 && (
                <ul className="absolute z-10 w-full bg-white border border-gray-300 rounded-md mt-1 max-h-60 overflow-y-auto shadow-lg">
                    {results.map(vendor => (
                        <li
                            key={vendor.id}
                            onMouseDown={() => handleSelect(vendor)}
                            className="p-2 hover:bg-gray-100 cursor-pointer"
                        >
                            {vendor.basicInfo.legalName}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}